// @flow
import React from 'react';
import { Translate } from 'react-localize-redux';

import { LANGUAGE_FRENCH } from '../constants';

export const generateAccountTypeList = (originString, mapping) => {
  let newString = '';

  mapping.forEach(item => {
    if (item.value === originString) {
      newString = item.text;
    }
    return newString;
  });
  return newString;
};

export const validateDate = date => {
  if (!date || Number.isNaN(Date.parse(date))) {
    return false;
  }
  return true;
};

export const convertUtcToLocalTime = (date, options) => {
  // Create a new Date object with the UTC time
  const utcTime = new Date(`${date} UTC`);
  // Convert the UTC time to local time with the specified format
  const localTime = utcTime.toLocaleString('en-US', options);
  // return format(mm/dd/yyyy)
  return localTime;
};

// used for example: 2021/01/31(YYYY/MM/DD)=> En:01/31/2019 FR:31/01/2021
// used for example: 01/31/2021(MM/DD/YYYY)=> En:01/31/2019 FR:31/01/2021
export const reverseInceptionDate = (date: string, language: string) => {
  if (validateDate(date)) {
    const newDate = new Date(date);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    const formattedDate = newDate.toLocaleDateString('en-US', options);
    const array = formattedDate.split('/');
    if (language !== LANGUAGE_FRENCH) {
      return `${array[0]}/${array[1]}/${array[2]}`;
    }
    return `${array[1]}/${array[0]}/${array[2]}`;
  }
  return '';
};

// used for example: 2021/01/31(YYYY/MM/DD)=> En:01/31/2019 FR:31/01/2021
// used for example: 01/31/2021(MM/DD/YYYY)=> En:01/31/2019 FR:31/01/2021
export const reverseDateString = (date: string, language: string) => {
  if (validateDate(date)) {
    // Define the options for date formatting
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const newDate = convertUtcToLocalTime(date, options);
    const array = newDate.split('/');

    if (language !== LANGUAGE_FRENCH) {
      return `${array[0]}/${array[1]}/${array[2]}`;
    }
    return `${array[1]}/${array[0]}/${array[2]}`;
  }
  return '';
};

// used for example: 01/31/2020 14:30(MM/DD/YYYY h:m)=>En:01/31/2020 14:30 FR:31/01/2020 14h30
export const reverseDateAndTime = (date: string, language: string) => {
  if (validateDate(date)) {
    // Define the options for date formatting
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
    };
    const newDate = convertUtcToLocalTime(date, options);

    const arraySplit = newDate.split(' ');

    const arrayDate = arraySplit[0].split('/');
    const arrayTime = arraySplit[1].split(':');
    const formatYear = arrayDate[2].substring(0, arrayDate[2].length - 1);
    if (language !== LANGUAGE_FRENCH) {
      return `${arrayDate[0]}/${arrayDate[1]}/${formatYear} ${arraySplit[1]}`;
    }
    return `${arrayDate[1]}/${arrayDate[0]}/${formatYear} ${arrayTime[0]}h${arrayTime[1]}`;
  }
  return '';
};

// used for example: December 03, 2012 => En:December 03, 2012  FR: 03 décembre 2012

// input will change to 12/03/2012 => En:December 03, 2012  FR: 03 décembre 2012
export const reverseLongListDate = (date: string, language: string, mapping) => {
  if (validateDate(date)) {
    // Define the options for date formatting
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const newDate = convertUtcToLocalTime(date, options);

    const array = newDate.split('/');
    if (language !== LANGUAGE_FRENCH) {
      return (
        <>
          <Translate id={generateAccountTypeList(array[0], mapping)} /> {array[1]}
          {','} {array[2]}
        </>
      );
    }
    return (
      <>
        {array[1]} <Translate id={generateAccountTypeList(array[0], mapping)} /> {array[2]}
      </>
    );
  }
  return '';
};

// example: May 22, 2024 at 12:21am => EN:May 22, 2024 at 12:21am FR:22 mai 2024 à 0h21
// will change to 05/22/2024 12:21 => EN:May 22, 2024 at 12:21am FR:22 mai 2024 à 12h21
export const reverseLongListDateAndTime = (date: string, language: string, mapping) => {
  if (validateDate(date)) {
    // Define the options for date formatting
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
    };
    const newDate = convertUtcToLocalTime(date, options);

    // arrayDate[0]:05/22/2024, arrayDate[1]:12:21
    const arrayDate = newDate.split(' ');

    // splitDate[0]: 05 splitDate[0]: 22 splitDate[0]: 2024,
    const splitDate = arrayDate[0].split('/');
    const splitTime = arrayDate[1].split(':');

    let displayHour = '';
    let amOrpm = '';
    if (splitTime[0] > 12) {
      displayHour = Number(splitTime[0]) - 12;
      amOrpm = 'pm';
    } else {
      displayHour = Number(splitTime[0]);
      amOrpm = 'am';
    }
    if (language !== LANGUAGE_FRENCH) {
      return (
        <>
          <Translate id={generateAccountTypeList(splitDate[0], mapping)} /> {splitDate[1]}
          {','} {splitDate[2].substring(0, splitDate[2].length - 1)} {'at'} {''}
          {displayHour}
          {':'}
          {splitTime[1]}
          {amOrpm}
        </>
      );
    }
    return (
      <>
        {splitDate[1]} <Translate id={generateAccountTypeList(splitDate[0], mapping)} />{' '}
        {splitDate[2].substring(0, splitDate[2].length - 1)} {'à'} {''}
        {splitTime[0]}
        {'h'}
        {splitTime[1]}
      </>
    );
  }
  return '';
};

// example: May 22, 2024 at 12:21AM => EN:May 22, 2024 at 12:21AM FR:22 mai 2024 à 0h21
// will change to 05/22/2024 12:21 => EN:May 22, 2024 at 12:21AM FR:22 mai 2024 à 12h21
export const reverseLongListDateAndTimeUpperCase = (date: string, language: string, mapping) => {
  if (validateDate(date)) {
    // Define the options for date formatting
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      minute: '2-digit',
    };
    const newDate = convertUtcToLocalTime(date, options);

    // arrayDate[0]:05/22/2024, arrayDate[1]:12:21
    const arrayDate = newDate.split(' ');

    // splitDate[0]: 05 splitDate[0]: 22 splitDate[0]: 2024,
    const splitDate = arrayDate[0].split('/');
    const splitTime = arrayDate[1].split(':');

    const hour24 = Number(splitTime[0]);
    let displayHour = '';
    let amOrpm = '';
    if (hour24 === 0) {
      displayHour = 12;
      amOrpm = 'AM';
    } else if (hour24 < 12) {
      displayHour = hour24;
      amOrpm = 'AM';
    } else if (hour24 === 12) {
      displayHour = 12;
      amOrpm = 'PM';
    } else {
      displayHour = hour24 - 12;
      amOrpm = 'PM';
    }
    if (language !== LANGUAGE_FRENCH) {
      return (
        <>
          <Translate id={generateAccountTypeList(splitDate[0], mapping)} /> {splitDate[1]}
          {','} {splitDate[2].substring(0, splitDate[2].length - 1)} {'at'} {''}
          {displayHour}
          {':'}
          {splitTime[1]}
          {amOrpm}
        </>
      );
    }
    return (
      <>
        {splitDate[1]} <Translate id={generateAccountTypeList(splitDate[0], mapping)} />{' '}
        {splitDate[2].substring(0, splitDate[2].length - 1)} {'à'} {''}
        {hour24}
        {'h'}
        {splitTime[1] === '00' || splitTime[1] === '0' ? '' : splitTime[1]}
      </>
    );
  }
  return '';
};

export const formatNumberAndCharacters = (data: string) => {
  if (!data) {
    return '';
  }
  const regexp = /[^0-9a-zA-Z]*/g;
  return data.replace(regexp, '');
};

export const formatRrcodeList = (data: string) => {
  if (!data) {
    return '';
  }
  const regexp = /[^0-9a-zA-Z-]*/g;
  return data.replace(regexp, '');
};

export const getIndexOf = (stringArray: Array<any>, val: string) => {
  for (
    let i = 0;
    i < stringArray.length;
    i++ // eslint-disable-line
  ) {
    if (stringArray[i].accessor === val) return i;
  }
  return -1;
};

export const removeIndex = (stringArray: Array<any>, val: string) => {
  const index = getIndexOf(stringArray, val);
  if (index > -1) {
    stringArray.splice(index, 1);
  }
  return stringArray;
};

export const removeNewlines = str => str.replace(/(?:\r\n|\r|\n|<br>)/g, ' ');

export const escapeHtml = text => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, m => map[m]);
};

export const replaceNewlinesToBr = text => {
  if (!text) {
    return '';
  }
  return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
};
